import type { LabeledStat } from '@/components/common/StatCardGrid';
import { TAKA_SYMBOL } from '@/constants/app.constants';
import type { MpRegionReport } from '../types/marketPromotion.types';

const REGION_TOTAL_HINT =
  'Each donation is counted once, even when one region is part of another region.';

export function getRegionReportStatCards(
  totals: MpRegionReport['totals'] | undefined,
  isRegionTab: boolean,
): LabeledStat[] {
  return [
    {
      key: 'distributed',
      label: 'Distributed',
      value: totals?.distributedAmount,
      unit: TAKA_SYMBOL,
      hint: isRegionTab ? REGION_TOTAL_HINT : undefined,
    },
    { key: 'donations', label: 'Donations', value: totals?.donations },
  ];
}
